const FinalOpportunity = () => (
    <section id="final-opportunity">
        <div className="container-fluid pt-4 pb-4 text-center gg-bg-solid-green text-white">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <h3><b>That’s Why We’re Giving You This Final Opportunity To Stay Stocked:</b></h3>
                </div>
            </div>
        </div>
    </section>
);

export default FinalOpportunity;